import React from 'react';
import { toast } from 'sonner';
import { CheckCircle2, Send } from 'lucide-react';

export const showSuccessToast = (name: string, type: 'contact' | 'subscription' = 'contact') => {
  const firstName = name.split(' ')[0];
  
  toast.custom((t) => (
    <div className={`
      relative overflow-hidden rounded-[1rem] p-5 shadow-xl transition-all duration-300
      bg-white dark:bg-gray-800 border border-gray-100 dark:border-gray-700
      text-gray-900 dark:text-white
      animate-in fade-in slide-in-from-bottom-4
    `}>
      <div className="relative z-10 flex items-start gap-4">
        <div className="flex-shrink-0 bg-optibiz-blue/10 p-2.5 rounded-xl text-optibiz-blue dark:text-blue-400">
          <CheckCircle2 className="w-6 h-6" />
        </div>
        
        <div className="flex-grow">
          <h3 className="text-lg font-bold mb-0.5">
            {type === 'contact' ? 'Message Received' : 'Subscription Confirmed'}
          </h3>
          <p className="text-sm text-gray-500 dark:text-gray-400 leading-relaxed">
            {type === 'contact' 
              ? `Thank you, ${firstName}. Your inquiry has been sent to our team.`
              : `Thank you for subscribing, ${firstName}. You'll receive updates soon.`
            }
          </p>
        </div>
      </div>
    </div>
  ), {
    duration: 5000,
    position: 'bottom-right',
  });
};
